export default __webpack_public_path__ + "static/media/PessoasExchange.6b925464.png";